import MainPage from './container/MainPage';
import logo from './logo.svg';
import './Main.css';

function App() {
  return (
    <div className="App">
      <MainPage />
    </div>
  );
}

export default App;
